/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const deleteApiCostcentersIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const deleteApiCostcentersId200Schema = z.any();

export const deleteApiCostcentersIdMutationResponseSchema = z.lazy(
  () => deleteApiCostcentersId200Schema,
);
